<script setup lang="ts">
import { onBeforeMount } from 'vue';
import ProfileGeneral from './components/ProfileGeneral.vue';
import ProfileLocation from './components/ProfileLocation.vue';
import ProfileNotifications from './components/ProfileNotifications.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import { PersonStores } from '@/store';

const profileStore = PersonStores.useUserProfileStore();

onBeforeMount(async () => await profileStore.getAuthUserProfile());
</script>

<template>
  <div class="page-container profile-page-container">
    <div class="page-header">
      <h1>Profile</h1>
    </div>
    <div class="page-content">
      <div class="md:col-6 col-12">
        <ProfileGeneral />
      </div>
      <div class="md:col-6 col-12 pr-0">
        <ProfileLocation />
      </div>
      <div
        v-if="can([PERMISSIONS.NOTIFICATIONS_EMAIL_FORWARD, PERMISSIONS.NOTIFICATIONS_EVENT_REMINDER])"
        class="md:col-6 col-12 pr-0"
      >
        <ProfileNotifications />
      </div>
    </div>
  </div>
</template>
